import script from "./FormSuratPernyataanCalonPJO.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSuratPernyataanCalonPJO.vue?vue&type=script&setup=true&lang=js"

import "./FormSuratPernyataanCalonPJO.vue?vue&type=style&index=0&id=a646bc24&lang=css"

const __exports__ = script;

export default __exports__